module.exports = __webpack_public_path__ + "img/scheme4.d6bc6ee8.png";